import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';

export type JevRecordType = 'contact' | 'segment' | 'sequence' | 'interactive_campaign';
export interface JevRecord { type: JevRecordType; id: string }
export interface JevPage { route: string; record: JevRecord | null }

// Registro aberto informado pela própria tela (vale mais que o da URL)
let registered: JevRecord | null = null;
const listeners = new Set<() => void>();
const subscribe = (fn: () => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; };
const setRegistered = (r: JevRecord | null) => { registered = r; listeners.forEach((fn) => fn()); };

const ID = /^[\w-]{1,64}$/;

/** Registro pela URL: /sequencias/:id, /campanhas/interativa/:id, ?segmento=, ?contato= */
export function recordFromUrl(pathname: string, search: string): JevRecord | null {
  const seq = pathname.match(/^\/sequencias\/([\w-]+)/);
  if (seq && seq[1] !== 'nova' && ID.test(seq[1])) return { type: 'sequence', id: seq[1] };
  const ic = pathname.match(/^\/campanhas\/interativa\/([\w-]+)/);
  if (ic && ic[1] !== 'nova' && ID.test(ic[1])) return { type: 'interactive_campaign', id: ic[1] };
  const q = new URLSearchParams(search);
  const pick = (key: string, type: JevRecordType) => { const v = q.get(key); return v && ID.test(v) ? { type, id: v } : null; };
  return pick('segmento', 'segment') || pick('contato', 'contact');
}

/** Tela atual para a Lumi: rota e registro aberto */
export function useJevContext(): JevPage {
  const { pathname, search } = useLocation();
  const reg = useSyncExternalStore(subscribe, () => registered);
  return { route: `${pathname}${search}`.slice(0, 200), record: reg ?? recordFromUrl(pathname, search) };
}

/** Para telas de detalhe: informa o registro aberto enquanto a tela estiver montada */
export function useJevRecord(record: JevRecord | null) {
  const key = record ? `${record.type}:${record.id}` : '';
  useEffect(() => {
    setRegistered(record);
    return () => setRegistered(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
